import Root from "./ArrowRoot.svelte"

export type { ArrowRootProps } from "./ArrowRoot.svelte"
export const Arrow = {
  Root,
}
